import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import _isEmpty from "lodash/isEmpty";
import _isFunction from "lodash/isFunction";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import PropTypes from 'prop-types';
import exactMath from 'exact-math';
import { Row, Col, Paper, BorrowerIncomeForm, BorrowerIncomeItem } from 'components';
import { formTitle, noRecords } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var BorrowerIncomeTab = function BorrowerIncomeTab(_ref) {
  var _borrower$incomes$red, _borrower$incomes, _borrower$incomes5, _borrower$incomes$;

  var borrower = _ref.borrower,
      idNumber = _ref.idNumber,
      onBorrowerChange = _ref.onBorrowerChange;
  var totalIncome = (_borrower$incomes$red = borrower === null || borrower === void 0 ? void 0 : (_borrower$incomes = borrower.incomes) === null || _borrower$incomes === void 0 ? void 0 : _borrower$incomes.reduce(function (n, _ref2) {
    var amount = _ref2.amount;
    return exactMath.add(Number(n), Number(amount));
  }, 0)) !== null && _borrower$incomes$red !== void 0 ? _borrower$incomes$red : 0;

  var handleEdit = function handleEdit(data) {
    var _borrower$incomes2;

    var editData = borrower === null || borrower === void 0 ? void 0 : (_borrower$incomes2 = borrower.incomes) === null || _borrower$incomes2 === void 0 ? void 0 : _borrower$incomes2.map(function (el) {
      return (el === null || el === void 0 ? void 0 : el.id) === (data === null || data === void 0 ? void 0 : data.id) ? data : el;
    });
    _isFunction(onBorrowerChange) && onBorrowerChange(editData);
  };

  var handleDelete = function handleDelete(id) {
    var _borrower$incomes3;

    var deleteData = borrower === null || borrower === void 0 ? void 0 : (_borrower$incomes3 = borrower.incomes) === null || _borrower$incomes3 === void 0 ? void 0 : _borrower$incomes3.filter(function (el) {
      return (el === null || el === void 0 ? void 0 : el.id) !== id;
    });
    _isFunction(onBorrowerChange) && onBorrowerChange(deleteData);
  };

  var handleAdd = function handleAdd(data) {
    var _borrower$incomes4;

    _isFunction(onBorrowerChange) && onBorrowerChange([].concat(_toConsumableArray((_borrower$incomes4 = borrower === null || borrower === void 0 ? void 0 : borrower.incomes) !== null && _borrower$incomes4 !== void 0 ? _borrower$incomes4 : []), [data]));
  };

  return ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0437\u0430 \u043F\u0440\u0438\u0445\u043E\u0434\u0438",
    margin: "0 0 2em 0"
  }, !_isEmpty(borrower === null || borrower === void 0 ? void 0 : borrower.incomes) ? ___EmotionJSX(React.Fragment, null, borrower === null || borrower === void 0 ? void 0 : (_borrower$incomes5 = borrower.incomes) === null || _borrower$incomes5 === void 0 ? void 0 : _borrower$incomes5.map(function (el) {
    return ___EmotionJSX(BorrowerIncomeItem, {
      data: el,
      key: el === null || el === void 0 ? void 0 : el.id,
      onEdit: handleEdit,
      onDelete: handleDelete
    });
  }), ___EmotionJSX("p", null, ___EmotionJSX("b", null, "\u041E\u0431\u0449\u043E \u043F\u0440\u0438\u0445\u043E\u0434\u0438:"), " ", "".concat(totalIncome, " ").concat(borrower === null || borrower === void 0 ? void 0 : (_borrower$incomes$ = borrower.incomes[0]) === null || _borrower$incomes$ === void 0 ? void 0 : _borrower$incomes$.currency))) : ___EmotionJSX("div", {
    css: noRecords
  }, ___EmotionJSX("p", null, "\u041D\u044F\u043C\u0430 \u0434\u043E\u0431\u0430\u0432\u0435\u043D\u0438 \u0437\u0430\u043F\u0438\u0441\u0438.")), ___EmotionJSX("h5", {
    css: formTitle
  }, "\u0414\u043E\u0431\u0430\u0432\u0438 \u043F\u0440\u0438\u0445\u043E\u0434"), ___EmotionJSX(BorrowerIncomeForm, {
    idNumber: idNumber,
    onBorrowerChange: handleAdd
  }))));
};

BorrowerIncomeTab.propTypes = {
  borrower: PropTypes.object,
  idNumber: PropTypes.string,
  onBorrowerChange: PropTypes.func
};
export default BorrowerIncomeTab;